(function CruiseDecks($, Adzuki)
{
	"use strict";
	$(document).ready(function documentReady()
	{
		if ($(".ship-decks").length > 0) {
			$('.ship-decks figure').click(function showDeckModal(e) {
				// var $modal = $(".ship-decks .modal");
				var url    = $(this).data("url");
				var title  = $(this).find('.caption').text();
				var $modal = $('.modal');
				var $img   = $('<img class="deck-image img-responsive"/>');

				$img.attr('src', Adzuki.base_uri + url);
				$img.attr('alt', title);
				$img.css('margin', 'auto').css('display', 'block');
				$modal.find('.modal-body').html('<div class="adz-magnifier-container center-block"></div>');
				$modal.find('.modal-dialog').addClass('modal-lg');
				$img.appendTo($modal.find('.adz-magnifier-container'));
				$modal.find('.modal-title').text(title);
				$modal.modal('show');
				
				$modal.on('shown.bs.modal', function init(e) {
					Adzuki.MagnifierGlass('.adz-magnifier-container');
				});
			});
		}
	});

}(jQuery, window.Adzuki || {}));
